import moment from 'moment';
import 'moment/locale/zh-cn';
import $ from 'jquery';
import nodeConfig from 'MODEL/config';
import { Toast } from 'antd-mobile';
import ZhCn from 'RESOURCE/zh.cn';
import EnUs from 'RESOURCE/en.us';
import PtPt from 'RESOURCE/pt.pt';
import FrFr from 'RESOURCE/fr.fr';
import {langRelations} from 'MODEL/languages';

let html5ImgCompress = require('STATIC/html5ImgCompress.min.js');


moment.locale('zh-cn');

const Utility = {
  User: {
    setUserInfoDevice: (query) => {
      const params = {};
      if (query.kjtToken && query.kjtToken !== '') {
        params.kjtToken = query.kjtToken;
      }
      if (query.deviceId && query.deviceId !== '') {
        params.deviceId = query.deviceId;
      }
      if (query.deviceType && query.deviceType !== '') {
        params.deviceType = query.deviceType;
      }
      Utility.Session.setItem('UserInfoDevice', JSON.stringify(params));
    },
    getUserInfoDevice: () => (Utility.Session.getItem('UserInfoDevice')
      ? JSON.parse(Utility.Session.getItem('UserInfoDevice'))
      : ''), // return Utility.Cookie.getValue('UserInfo')

    setUser: (obj) => {
      Utility.Session.setItem('UserInfo', JSON.stringify(obj));
      // Utility.Cookie.setValue('UserInfo', obj)
    },
    getUser: () => (Utility.Session.getItem('UserInfo')
      ? JSON.parse(Utility.Session.getItem('UserInfo'))
      : ''), // return Utility.Cookie.getValue('UserInfo')

    clearUser: () => {
      Utility.Session.removeItem('UserInfo');
      // Utility.Cookie.clear('UserInfo')
    },
  },
  Bank: {
    setBank: (obj) => {
      Utility.Session.setItem('BankInfo', JSON.stringify(obj));
      // Utility.Cookie.setValue('BankInfo', obj)
    },
    getBank: () => (Utility.Session.getItem('BankInfo')
      ? JSON.parse(Utility.Session.getItem('BankInfo'))
      : ''), // return Utility.Cookie.getValue('BankInfo')

    clearBank: () => {
      Utility.Session.removeItem('BankInfo');
      // Utility.Cookie.clear('BankInfo')
    },
  },
  dateFormaterObj(value) {
    if (!value) {
      return false;
    }

    return moment(value, 'YYYY-MM-DD');
  },
  dateFormaterString(value) {
    return value.format('YYYY-MM-DD');
  },
  getShortDate(value) {
    if (!value) {
      return '';
    }
    const date = new Date(value.replace(/-/g, '/'));
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  },
  getMobileate(value) {
    if (!value) {
      return '';
    }
    const date = new Date(value);
    let month = date.getMonth() + 1;
    if (month<10) {
      month = '0'+''+month;
    }
    let day = date.getDate();
    if (day<10) {
      day = '0'+''+day;
    }
    (date.getMonth() + 1)
    return `${date.getFullYear()}-${month}-${day}`;
  },
  setTitle: (val) => {
    const $body = $('body');
    document.title = val;
    if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      const $iframe = $('<iframe style="width:0;height:0;opacity: 0;"></iframe>');
      $iframe
        .on('load', () => {
          setTimeout(() => {
            $iframe.off('load').remove();
          }, 0);
        })
        .appendTo($body);
    }
  },
  getSearchParams() {
    const args = {};
    const query = window.location.search.substring(1);
    const pairs = query.split('&');
    for (let i = 0; i < pairs.length; i += 1) {
      const pos = pairs[i].indexOf('=');
      if (pos !== -1) {
        const name = pairs[i].substring(0, pos);
        let value = pairs[i].substring(pos + 1);
        value = decodeURIComponent(value);
        args[name] = value;
      }
    }
    return args;
  },
  clearSpace(val) {
    return val.replace(/\s/g, '');
  },

  addFK(fpHost, staticHost) {
    // 引入分控
    const sarsTokenId = `h5${new Date().getTime()}${Math.ceil(
      Math.random() * 700 + 1000,
    )}`;
    window._fmOpt = {
      partner: 'kjtpay',
      appName: 'kjtpay_web',
      token: sarsTokenId,
      fmb: true,
      success(data) {
        // 在成功完成采集后，success回调中可以获取到blackbox
        window.blackbox = data;
      },
      fpHost,
      staticHost,
    };

    const cimg = new Image(1, 1);
    cimg.onload = () => {
      window._fmOpt.imgLoaded = true;
    };
    cimg.src = `${
      window._fmOpt.fpHost
    }/fp/clear.png?partnerCode=kjtpay&appName=kjtpay_web&tokenId=${
      window._fmOpt.token
    }`;
    const fm = document.createElement('script');
    fm.type = 'text/javascript';
    fm.async = true;
    fm.src = `${(document.location.protocol === 'https:'
      ? 'https://'
      : 'http://') + window._fmOpt.staticHost}/v3/fm.js?ver=0.1&t=${(
      new Date().getTime() / 3600000
    ).toFixed(0)}`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(fm, s);
  },
  CommonUrl: {
    setCommonUrl: (obj) => {
      Utility.Session.setItem('CommonUrl', JSON.stringify(obj));
    },
    getCommonUrl: () => {
    },
    clearCommonUrl: () => {
      Utility.Session.removeItem('CommonUrl');
    },
  },
  Cookie: {
    setValue(cname, cvalue, needJson, exdays) {
      let expires = '';
      if (exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        expires = `;expires=${d.toUTCString()}`;
      }
      if (needJson) {
        document.cookie = `${cname}=${escape(cvalue)}${expires};path=/`;
      } else {
        document.cookie = `${cname}=${escape(
          JSON.stringify(cvalue),
        )}${expires};path=/`;
      }
    },
    getValue(cname, needJson) {
      const name = `${cname}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) !== -1) {
          let s;
          try {
            if (needJson) {
              s = unescape(c.substring(name.length, c.length));
            } else {
              s = JSON.parse(unescape(c.substring(name.length, c.length)));
            }
          } catch (e) {
            // alert('上次未能正确关闭浏览器，请重启浏览器。');
          }
          return s;
        }
      }
      return '';
    },
    clear(name) {
      this.setValue(name, '', false, -1);
    },
  },
  Session: {
    // 替换页面的Utility.Session
    clear: () => {
      localStorage.clear();
    },
    setItem: (name, value) => {
      localStorage.setItem(name, value);
      // Utility.Cookie.setValue(name, value, true)
    },
    getItem: name => localStorage.getItem(name), // return Utility.Cookie.getValue(name, true)

    removeItem: (name) => {
      localStorage.removeItem(name);
      // Utility.Cookie.clear(name)
    },
  },
  hideKeyBoard: () => {
    sessionStorage.removeItem('mapArr');
    sessionStorage.removeItem('randKey');
    sessionStorage.removeItem('rsaPublicKey');

    if (window.PassGlobal && window.PassGlobal.kb) {
      if (
        document.getElementById('testkbid')
        && document.getElementById('testkbid').style.display === 'block'
      ) {
        // window.PassGlobal["mixture"].clearpwd()

        window.PassGlobal.kb.hide();
      }

      // delete window.PassGlobal;
    }

    if (window.PassGlobalSix && window.PassGlobalSix.kb) {
      if (
        document.getElementById('testkbid')
        && document.getElementById('testkbid').style.display === 'block'
      ) {
        // window.PassGlobal["mixture"].clearpwd()

        window.PassGlobalSix.kb.hide();
      }
      // delete window.PassGlobalSix;
    }
  },
  loading: () => {
    document.getElementById('app').innerHTML = '<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  },
  getOrigin() {
    let _domain = '';
    if (window.location.origin) { // IE多数分支取不到origin值
      _domain = window.location.origin;
    } else {
      _domain = `${window.location.protocol}//${window.location.host}`;
    }
    return _domain;
  },
  // 获取密码控件随机因子url
  getMappUrl() {
    let _domain = '';
    if (__DEV__) {
      _domain = nodeConfig.devApiAddress;
    } else {
      _domain = `${Utility.getOrigin()}/${nodeConfig.apiAddress}`;
    }
    return `${_domain}/common/getRandomKey`;
  },
  getMemberId: () => {
     let searchPara = Utility.getSearchParams();
     if (searchPara.memberId) {
       return searchPara.memberId;
     } else {
       return '';
     }
     // return sessionStorage.getItem('MemberId');
  },
  getUploadObj: function(params, files, callback) {
      let _domain = Utility.getDomain();
      let singleFile = files;
      let needCompress = true;
      if (needCompress) {
        new html5ImgCompress(singleFile, {
          maxWidth: 1500,
          maxHeight: 1500,
          quality: 0.8,
          before: function(file) {
            // 这里一般是对file进行filter，例如用file.type.indexOf('image') > -1来检验是否是图片
            // 如果为非图片，则return false放弃压缩（不执行后续done、fail、complete），并相应提示
          },
          done: function (file, base64) {
            let compressImg = getFile(base64, file.name);
            doUpload(compressImg);
          },
          fail: function(file) {
            doUpload(singleFile);
          },
          complete: function(file) {

          },
          notSupport: function(file) {
            doUpload(singleFile);
            // 不支持操作，例如PC在这里可以采用swfupload上传
          }
        });
      } else {
        doUpload(singleFile);
      }

      function doUpload(paraFile) {
        // let userInfo = Utility.Cookie.getValue('MemberInfo');
        let searchPara = ''
        if(params.body) {
            searchPara = params.body
        }
        var form = new FormData();
        form.append("file_select",paraFile, paraFile.name);
        $.ajax({
              type: "post",
              url: _domain + '/common/file/uploadFile'+searchPara + '&memberId=' + Utility.getMemberId(),
              data: form,
              headers:{
                //'SARS-TOKEN-ID': window._fmOpt ? window._fmOpt.getinfo() : "",
                // 'X-SSO-Auth': userInfo.token,
                //'X-USER-Auth': userInfo.token,
                //'X-USER-Auth-PartnerId': partnerId,
                'X-KJT-Agent': ';;;;;;;default',
                Accept: '*/*'
              },
              contentType: false, // 注意这里应设为false
              processData: false,    //false
              cache: false,    //缓存
              success: function(data){
                if (callback && typeof callback == 'function') {
                  if(data.status == '0') {
                    callback(true, data);
                  } else {
                    Toast.info(data.message, 1);
                  }

                }
              },
              error: function(e) {
                if (callback && typeof callback == 'function') {
                  callback(false, e);
                }
                Toast.info("上传失败", 1);
              }
        });
      }


      function dataURLtoFile(dataurl, filename) {//将base64转换为文件
          let arr = dataurl.split(',');
          let mime = arr[0].match(/:(.*?);/)[1];
          let bstr = atob(arr[1]);
          let n = bstr.length;
          let u8arr = new Uint8Array(n);
          while(n--){
              u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, {type:mime});
      }

      function getFile(dataurl, filename) {
          var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
          while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
          }

          var blob = new Blob([u8arr], { type: mime });
          blob.lastModifiedDate = new Date();
          blob.name = filename;
          return blob;
     }

  },
  getDomain: function() {
    var _domain = nodeConfig.devGatewayAddress;
    if (__DEV__) {
      _domain = nodeConfig.devGatewayAddress;
    } else {
      _domain = Utility.getOrigin() + '/' + nodeConfig.gatewayApiAdress;
    }
    return _domain;
  },
   //Gateway版文件上传
   getGatewayUploadObj: function(params, files, callback) {
   
    let _domain = Utility.getDomain();
    let singleFile = files;
    let needCompress = true;
    if(singleFile.type.indexOf('image') > -1) {
            
    } else {
      needCompress=false;
    }
    if (needCompress) {
      new html5ImgCompress(singleFile, {
        maxWidth: 1200,
        maxHeight: 1200,
        quality: 0.8,
        before: function(file) {
          
          // 这里一般是对file进行filter，例如用file.type.indexOf('image') > -1来检验是否是图片
          // 如果为非图片，则return false放弃压缩（不执行后续done、fail、complete），并相应提示
        },
        done: function (file, base64) {
          let compressImg = getFile(base64, file.name);
          doGatewayUpload(compressImg);
        },
        fail: function(file) {
          doGatewayUpload(singleFile);
        },
        complete: function(file) {

        },
        notSupport: function(file) {
          doGatewayUpload(singleFile);
          // 不支持操作，例如PC在这里可以采用swfupload上传
        }
      });
    } else {
      
      doGatewayUpload(singleFile);
    }

    function doGatewayUpload(paraFile) {
     console.log('dddd', paraFile)
      // let userInfo = Utility.Cookie.getValue('MemberInfo');
      let searchPara = ''
      if(params.body) {
          searchPara = params.body
      }
      
      var form = new FormData();
     
      // data:{
            //   "bizType":'slzf',
            //   "sysCode":"slzf",
            //   "requestBaseStr":JSON.stringify(_gateway)
            // },
      let userInfo = Utility.User.getUser();
      // let userToken = "",
      //   ssoToken = "",
      //   bdUserToken="",//bd地推人员登录头信息
      //   partnerId = "",
      //   h5Token="";
      // if (userInfo) {
      //   userToken = userInfo.userToken;
      //   h5Token = userInfo.h5Token;
      //   ssoToken = userInfo.ssoToken;
      //   partnerId = userInfo.partnerId;
      //   bdUserToken = userInfo.bdUserToken;
      // }

      let token = '';
      let tokenType = '';
      if(location.href.toLowerCase().indexOf('/app/')>-1) {
        token = userInfo.h5Token;
        tokenType = 'LOGIN-TOKEN';
      } else if (location.href.toLowerCase().indexOf('/plateform/')>-1) {
        token = userInfo.token;
        tokenType = 'SSO-AUTH';
      }else{
        //默认是刷脸系统
        token =  Utility.Session.getItem("faceOpenId");
        tokenType = 'THIRD-PARTY-AUTH';
      }
      let _gateway = {
        bizContent: "",
        loginAuthInfo: {
          isEnt: "",
          loginToken: token,
          loginTokenType: tokenType,
          operatorId: "",
          operatorName: "",
          partnerId: ""
        },
        requestNo: `requestno${new Date().getTime()}${parseInt(
          Math.random() * 1000000
        )}`,
        sarsTokenId: window.blackbox ? window.blackbox : "",
        service: "",
        sign: "",
        signType: "AES",
        language: sessionStorage.getItem('LANG') ? sessionStorage.getItem('LANG') : 'en',
        terminalInfo:{
          "appVersion": require('../../package.json').version,
          "deviceBrand": "",
          "deviceId": "",
          "deviceModel": "",
          "deviceType": "H5",
          "deviceVersion": "",
          "terminal": "H5",
          "userNetType": ""
        },
        timestamp: new Date().getTime(),
        version:params.version ? params.version : "1.0.0"
      }
      form.append("file",paraFile, paraFile.name);
      form.append("bizType","Photocopies");
      form.append("sysCode","gateway-inner");
      form.append("language",Utility.getLang()||'zh');
      form.append("requestBaseStr",JSON.stringify(_gateway));
      $.ajax({
            type: "post",
            url:  _domain + '/uploadFile',
            // url:'https://c1api-gateway.kjtpay.com/api-gateway/uploadFile?bizType=ddsc&fileName=testName',
            data: form,
            // headers: headers,
            contentType: false, // 注意这里应设为false
            processData: false,    //false
            cache: false,    //缓存
            success: function(data){
              if (callback && typeof callback == 'function') {
                if( data.code === "S0001") {
                  callback(true, data);
                } else {
                  Toast.info(data.msg, 1);//TODO  两层信息toast
                }

              }
            },
            error: function(e) {
              if (callback && typeof callback == 'function') {
                callback(false, e);
              }
              Toast.info("上传失败", 1);
            }
      });
    }


    function dataURLtoFile(dataurl, filename) {//将base64转换为文件
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }

    function getFile(dataurl, filename) {
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        var blob = new Blob([u8arr], { type: mime });
        blob.lastModifiedDate = new Date();
        blob.name = filename;
        return blob;
   }

  },
  message: (key) => {
      let cacheLang = Utility.getLang();;
      if(!cacheLang) {
        return PtPt[key];;
      }
      
     if(cacheLang == 'en') {
         return EnUs[key];
     } else if(cacheLang == 'zh') {
        return ZhCn[key];
    }else if(cacheLang == 'pt') {
        return PtPt[key];
    } else if(cacheLang == 'fr') {
      return FrFr[key];
  } else {
      return PtPt[key];
    }
    
  },
  getLang: () => {
    /*
      let nowLang = Utility.getSearchParams().language || sessionStorage.getItem('LANG')
      if(nowLang) {
          if (langRelations[nowLang]) {
            return langRelations[nowLang]
          } else {
            return langRelations['default'];
          }
          
      } else {
         return langRelations['default'];
      }
      */
      let nowLang = Utility.getSearchParams().language || sessionStorage.getItem('LANG')
      if(nowLang) {
        if (langRelations[nowLang]) {
          return langRelations[nowLang]
        } else {
          return langRelations['default'];
        }
        
    } else {
        let defLang = navigator.language.split(/[\-_]/)[0];
        if(langRelations[defLang]) {
            return langRelations[defLang];
        } else {
          return langRelations['default'];
        }
       
    }
  },
  appMessage: (para) => {
    let param = '';

    if(typeof para == 'object') {
      param = JSON.stringify(para);
    }

    console.log(param)
   
    var uAgent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/i.test(uAgent)) {
      if (typeof app_callback === "function") {
        app_callback(param);
      } else {
        try{
            window.webkit.messageHandlers.app_callback.postMessage(param);
        }catch(e){
            // alert('原生app不存在applogin方法');
        }
      }
    } else if(/android/i.test(uAgent)) {
      if (AppJs && AppJs.app_callback && typeof AppJs.app_callback === "function") {
        AppJs.app_callback(param);
      }
    }
    

    /*
     var uAgent = navigator.userAgent.toLowerCase();
          if (
            /iphone|ipad|ipod/.test(uAgent) &&
            typeof goAuthorize === "function"
          ) {
            goAuthorize();
          } else if (
            /android/.test(uAgent) &&
            typeof goAuthorize === "function"
          ) {
            goAuthorize();
          }
    */
  },
  getDateRange: (typ) => {
    switch(typ) {
        case '1': //昨天
        let today = new Date();
        let yesterday = new Date(today.setDate(today.getDate() - 1));

        return [Utility.dateMement(yesterday),Utility.dateMement(yesterday)];

        case '2'://本周
        return [moment().week(moment().week()).startOf('week'),moment().week(moment().week()).endOf('week')];

        case '3'://上周
        return [moment().week(moment().week()-1).startOf('week'),moment().week(moment().week()-1).endOf('week')];

        case '4'://本月
        return [moment().month(moment().month()).startOf('month'),moment().month(moment().month()).endOf('month')];

        case '5'://上月
        return [moment().month(moment().month()-1).startOf('month'),moment().month(moment().month()-1).endOf('month')];
        case '6'://近七天
        return [moment().subtract(6, "days"),moment()];
        case '7': //今天
        return [moment(),moment()];
        case '8'://近30天
        return [moment().subtract(30, "days"),moment()];
      }
  },
  dateMement: function(value, typeVal) {

      if (!value) {
          return
      }

       return moment(value)

  },
  isImage: function(value) {


     return ['jpg','jpeg','png','bmp','svg','gif','tiff'].indexOf(value.toLowerCase())>-1;

},
postMessage:(mes) => {
    if(typeof mes == 'object') {
      window.postMessage(mes, Utility.getOrigin());
    }
}
};

export default Utility;



// WEBPACK FOOTER //
// ./src/util/utility.js